import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map, Subscription } from 'rxjs';
import { SideNavComponent } from '../../shared/side-nav/side-nav.component';
import { HeaderComponent } from '../../shared/header/header.component';

@Component({
  selector: 'app-shell',
  standalone: true,
  imports: [CommonModule, RouterOutlet, SideNavComponent, HeaderComponent],
  templateUrl: './app-shell.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app-shell.component.scss',
})
export class AppShellComponent implements OnInit, OnDestroy {
  hideHeader = false;
  private subscription?: Subscription;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.hideHeader = this.getHideHeaderFromRoute();
    this.subscription = this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        map(() => this.getHideHeaderFromRoute())
      )
      .subscribe(hideHeader => {
        this.hideHeader = hideHeader;
      });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  private getHideHeaderFromRoute(): boolean {
    let route = this.router.routerState.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route.snapshot.data['hideHeader'] === true;
  }
}
